import { markRaw } from 'vue';

const queue = [];
const OVERLAY_PUSHED_EVENT = 'overlay:pushed';

const overlayQueue = new EventTarget();

/**
 * Enqueue a new overlay interaction.
 *
 * The overlay queue centralizes message dialogs and richer interactive
 * overlays so the app never presents competing modal surfaces at once.
 */
overlayQueue.pushOverlay = (overlayInfo) => {
  const preparedOverlayInfo = normalizeOverlayInfo(overlayInfo);
  queue.push(preparedOverlayInfo);
  overlayQueue.dispatchEvent(new Event(OVERLAY_PUSHED_EVENT));
};

/**
 * Dequeue the current overlay (i.e. remove and return the first queued item).
 */
overlayQueue.popOverlay = () => {
  const overlayInfo = queue.shift() || null;
  return overlayInfo;
};

/**
 * Exposes the queue event name so consumers do not duplicate string literals.
 *
 * @returns {string}
 */
overlayQueue.getOverlayPushedEventName = () => {
  return OVERLAY_PUSHED_EVENT;
};

/**
 * Normalizes overlay configuration by ensuring default values are set.
 */
function normalizeOverlayInfo(overlayInfo) {
  return {
    title: overlayInfo?.title ?? '',
    message: overlayInfo?.message ?? '',
    subMessage: overlayInfo?.subMessage ?? '',
    type: overlayInfo?.type ?? 'info',
    buttons: overlayInfo?.buttons?.length > 0 ? overlayInfo.buttons : null,
    closeAction: overlayInfo?.closeAction ?? null,
    component: overlayInfo?.component ? markRaw(overlayInfo.component) : null,
    componentProps: overlayInfo?.componentProps ?? {}
  };
}

export default overlayQueue;
